import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export default function useLoadingInViewport(wrapperRef, prefixCls, isSpinning) {
    const [isLoadingInViewport, setIsLoadingInViewport] = React.useState(false);
    React.useEffect(() => {
        var _a;
        if (!isSpinning || typeof window === 'undefined') {
            setIsLoadingInViewport(false);
            return undefined;
        }
        let animationFrame;
        const updateLoadingPosition = () => {
            if (animationFrame !== undefined) {
                window.cancelAnimationFrame(animationFrame);
            }
            animationFrame = window.requestAnimationFrame(() => {
                var _a;
                const tableNode = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${prefixCls}`);
                if (!tableNode) {
                    return;
                }
                const { top, bottom } = tableNode.getBoundingClientRect();
                const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                const shouldFixLoading = top <= 0 && bottom >= viewportHeight * 0.75;
                setIsLoadingInViewport(previous => previous === shouldFixLoading ? previous : shouldFixLoading);
            });
        };
        const tableNode = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`.${prefixCls}`);
        const resizeObserver = new ResizeObserver(updateLoadingPosition);
        if (tableNode) {
            resizeObserver.observe(tableNode);
        }
        updateLoadingPosition();
        document.addEventListener('scroll', updateLoadingPosition, true);
        window.addEventListener('resize', updateLoadingPosition);
        return () => {
            if (animationFrame !== undefined) {
                window.cancelAnimationFrame(animationFrame);
            }
            resizeObserver.disconnect();
            document.removeEventListener('scroll', updateLoadingPosition, true);
            window.removeEventListener('resize', updateLoadingPosition);
        };
    }, [isSpinning, prefixCls]);
    return isLoadingInViewport;
}
